module.exports = __webpack_public_path__ + "static/img/Banner02.e45edab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Banner02.jpg
// module id = 284
// module chunks = 2